import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-registry-list',
  templateUrl: './seo-registry-list.component.html',
  styleUrls: ['./seo-registry-list.component.css'],
})
export class SeoRegistryListComponent {
  url: string = 'seoRegistries';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  type = '';

  modalTitle: string = '';
  modalContent: string | null = null;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', this.type, this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response get', response);
        //this.data = response.data;
        // Ordenar por updatedAt (el más reciente primero)
        this.data = response.data.sort((a, b) => {
          return (
            new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
          );
        });
        this.filteredData = [...this.data];
        this.updateSuggestions();
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return item.name && item.name.toLowerCase().includes(texto);
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.name) sugerenciasSet.add(item.name);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
